import React from "react";
import "./Header.css";
import Title from "./Title";
import Subtitle from "./Subtitle";
import Button from "./Button";
import Paragraph from "./Paragraph";

const Header = () => {
  return (<>
    <header className="hero-img">

      <div className="hero-container">
      <Subtitle text="Since 1995" css3="subtitle"/>
        <Title text1="Strategic Legal Solutions with Integrity" css2="text2"/>
        <Paragraph text1="Exceptional legal representation with expertise and dedication" css5="paragraph"/>

        <Button text="Book Consultation" css4="button"/>
      </div>

    </header>
    </>);
};

export default Header;